export const WEBSITE_ORDER_CHANNEL = 2;
